import {colorSwatch} from '../utils/colorSwatch.js';
import {MenuPanels} from '../../models/UIModel.js';
import React, {useState, useMemo} from 'react';
import {
    formatString,
    insertNewlines,
    parseColor,
    resizeLabelToFit,
    setAlpha,
} from '../utils/utils.js';
import {MenuButton} from '../components/menu-button.js';
import {
    Column,
    Container,
    Image,
    Panel,
    Panel9Slice,
    ProgressBar,
    Row,
    Text,
} from '@wonderlandengine/react-ui/components';
import {
    Align,
    FlexDirection,
    Justify,
    PositionType,
    YogaNodeProps,
} from '@wonderlandengine/react-ui';
import {
    RotBMaterialContextValue,
    useRotBMaterialContext,
} from '../utils/rotb-material-context.js';
import {Texture} from '@wonderlandengine/api';
import {WindowHeader} from '../components/window-header.js';

import {UiTexturesManager} from '../components/ui-textures-manager.js';
import {Localization} from '../../utils/Localization.js';
import {Carousel, CarouselItem} from '../components/carousel.js';
import {SliderItem} from '../components/SliderComponent.js';
import {Window} from '../components/window.js';
import {BooleanName} from '../../enums/BooleanName.js';
import {BooleanStore} from '../../components/boolean-store.js';
import {ColoredImage} from '../components/colored-image.js';
import {RankManager} from '../../components/rank-manager.js';
import {formatNumber} from '../../utils/Utils.js';
import {UnlockManager} from '../../components/unlock-manager.js';
import {Sounds} from '../../enums/Sounds.js';
import {goToPreviousMenu} from '../utils/goToPreviousMenu.js';
import {FlatOpaqueTextured} from '../../types/materials.js';
import {AchievementIcons} from './notification.js';

export function getIsAchieved(booleanName: BooleanName) {
    const achieved = BooleanStore.instance.get(booleanName);
    return achieved;
}

export function lockImage(booleanName: BooleanName, image: Texture): Texture {
    if (getIsAchieved(booleanName)) {
        return image;
    } else {
        return AchievementIcons.instance.ach_general_icon;
    }
}

type AchievementSelectItem = {
    title: string;
    id: BooleanName;
    image: string;
};

const data: AchievementSelectItem[] = [
    {
        'title': '01 You got learned (AchievementLearned)',
        'id': 50,
        'image': 'ach_learned',
    },
    {
        'title': '02d Watchmaker (AchievementWatchMaker)',
        'id': 52,
        'image': 'ach_watchmaker',
    },
    {
        'title': '02b Bonehead (AchievementBoneHead)',
        'id': 53,
        'image': 'ach_bone_head',
    },
    {
        'title': '02c Professional (AchievementUnlockExpert)',
        'id': 24,
        'image': 'ach_unlock_expert',
    },
    {
        'title': '05 Environment (AchievementEnvironment)',
        'id': 51,
        'image': 'ach_environmentalist',
    },
    {
        'title': '05 Orion (AchievementTristar)',
        'id': 94,
        'image': 'ach_tristar',
    },
    {
        'title': '05 Rank 5 (AchievementRankLow)',
        'id': 41,
        'image': 'ach_rank5',
    },
    {
        'title': '05 Who Made This (AchievementWhoMadeThis)',
        'id': 61,
        'image': 'ach_who_made_this_game',
    },
    {
        'title': '10 A New Challenger (AchievementChallengerArrived)',
        'id': 56,
        'image': 'ach_new_challenger',
    },
    {
        'title': '10 All nighter (AchievementSunrise)',
        'id': 67,
        'image': 'ach_allnighter',
    },
    {
        'title': '10 fungicide (AchievementNumberMushrooms)',
        'id': 101,
        'image': 'ach_fungicide',
    },
    {
        'title': '10 millionaire mal (AchievementMillionaireMal)',
        'id': 47,
        'image': 'ach_millionaire',
    },
    {
        'title': '10 nature freak (AchievementNatureFreak)',
        'id': 60,
        'image': 'ach_nature_freak',
    },
    {
        'title': '10 Rank 10 (AchievementRankMedium)',
        'id': 54,
        'image': 'ach_rank10',
    },
    {
        'title': '10 strawberry blos (AchievementStrawberryBlobs)',
        'id': 35,
        'image': 'ach_strawberry_b_forever',
    },
    {
        'title': '15 color coordinator (AchievementColorCoordinator)',
        'id': 21,
        'image': 'ach_color_coordinator',
    },
    {
        'title': '15 pucker (AchievementPuckerUp)',
        'id': 39,
        'image': 'ach_pucker_up',
    },
    {
        'title': '15 fun guy (AchievementFunGuy)',
        'id': 23,
        'image': 'ach_fun_guy',
    },
    {
        'title': '15 pumpkin pi (AchievementPumpkinPi)',
        'id': 62,
        'image': 'ach_pumkin_pi',
    },
    {
        'title': '15 tetrominor (AchievementTetrimino)',
        'id': 42,
        'image': 'ach_tetrominor',
    },
    {
        'title': '15 time cop (AchievementTimeCop)',
        'id': 37,
        'image': 'ach_time_cop',
    },
    {
        'title': '20 1 starcatcher (AchievementStarCatcher)',
        'id': 97,
        'image': 'ach_starcatcher',
    },
    {
        'title': '20 2 nor-mal (AchievementNorMal)',
        'id': 32,
        'image': 'ach_normal',
    },
    {
        'title': '20 6 clockhead (AchievementClockHead)',
        'id': 33,
        'image': 'ach_clockhead',
    },
    {
        'title': '20 4 curses (AchievementCurses)',
        'id': 34,
        'image': 'ach_curses',
    },
    {
        'title': '20 5 match maker (AchievementExpertGames)',
        'id': 74,
        'image': 'ach_expert',
    },
    {
        'title': '20 7 mush (AchievementTotalNumberFungusGames)',
        'id': 100,
        'image': 'ach_truffleshuffle',
    },
    {
        'title': '20 3 cupcake (AchievementPlayNumberGamesCupcake)',
        'id': 112,
        'image': 'ach_cupcake',
    },
    {
        'title': '20 all juiced  (AchievementMaxPower)',
        'id': 36,
        'image': 'ach_max_power',
    },
    {
        'title': '20 blobs away (AchievementBlobsAway)',
        'id': 45,
        'image': 'ach_blobs_away',
    },
    {
        'title': '20 fashionable (AchievementFashionable)',
        'id': 65,
        'image': 'ach_fashion',
    },
    {
        'title': '10 moon child (AchievementMoonBlobs)',
        'id': 73,
        'image': 'ach_moon_blob',
    },
    {
        'title': '20b beat it (AchievementBeatEasy)',
        'id': 81,
        'image': 'ach_beat_normal',
    },
    {
        'title': '20f time after time (AchievementBeatTimeMode)',
        'id': 18,
        'image': 'ach_beat_timemode',
    },
    {
        'title': '20d final countdown (AchievementBeatSkull)',
        'id': 83,
        'image': 'ach_beat_skullmode',
    },
    {
        'title': '20e dont stop believeing (AchievementBeatNormal)',
        'id': 82,
        'image': 'ach_beat_expert',
    },
    {
        'title': '20a  welcome to the jungle (AchievementBeatQuickplay)',
        'id': 93,
        'image': 'ach_beat_quickplay',
    },
    {
        'title': '20g bad medicine (AchievementBeatFungusMode)',
        'id': 99,
        'image': 'ach_beat_fungus',
    },
    {
        'title': '20c  sweet dreams (AchievementBeatCupcakeMode)',
        'id': 111,
        'image': 'ach_beat_cupcake',
    },
    {
        'title': '25 da bomb (AchievementDaBomb)',
        'id': 48,
        'image': 'ach_da_bomb',
    },
    {
        'title': '25 head hunter (AchievementSkullSmasher)',
        'id': 38,
        'image': 'ach_skull_smasher',
    },
    {
        'title': '25 lucky 7 (AchievementLucky7)',
        'id': 44,
        'image': 'ach_lucky7',
    },
    {
        'title': '25 rank 25 (AchievementRankHigh)',
        'id': 40,
        'image': 'ach_rank25',
    },
    {
        'title': '50 rank 50 (AchievementRank50)',
        'id': 59,
        'image': 'ach_rank50',
    },
    {
        'title': '25 scale the castle (AchievementWindupKnight)',
        'id': 91,
        'image': 'ach_unlockwuk',
    },
    {
        'title': '25 tetromajor (AchievementTetriminoMaestro)',
        'id': 46,
        'image': 'ach_tetromino_maestro',
    },
    {
        'title': '25 waste the rainbow (AchievementWasteRainbow)',
        'id': 43,
        'image': 'ach_waste_rainbow',
    },
    {
        'title': '50 destroyer of blobs (AchievementDestroyerOfBlobs)',
        'id': 49,
        'image': 'ach_destroyer_blobs',
    },
];

function calcWorth() {
    let totalNum = 0;
    let numAchieved = 0;
    for (const item of data) {
        const worth = UnlockManager.instance.getAchievementWorth(item.id);
        totalNum += worth;

        if (getIsAchieved(item.id)) {
            numAchieved += worth;
        }
    }

    return `${numAchieved}/${totalNum}`;
}

export const AchievementsPanel = (props: React.PropsWithChildren<YogaNodeProps> & {}) => {
    const rotbMats = useRotBMaterialContext() as RotBMaterialContextValue;

    const progressMaterial = useMemo(() => {
        const x = rotbMats.whiteBevelMaterial!.clone() as FlatOpaqueTextured;
        x.setColor(parseColor(colorSwatch.RankProgress));
        return x;
    }, []);

    const rankText = useMemo(() => rotbMats.uiTextShadowMaterial!.clone(), []);
    const totalWorth = useMemo(() => calcWorth(), []);

    const [rank] = useState(
        formatString(
            Localization.instance.get('RankFormat'),
            formatNumber(RankManager.instance.rank)
        )
    );
    const [xpPercentage] = useState(RankManager.instance.currentRankPercentComplete);

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [isAchieved, setAchieved] = useState(true);
    const [worth, setWorth] = useState<string>('0');
    const [percentage, setPercentage] = useState(0);

    const onSelectionChanged = (item: SliderItem) => {
        const currentSelectedAchievement: AchievementSelectItem = data[item.id];
        const achieved = getIsAchieved(currentSelectedAchievement.id);
        const instructions = UnlockManager.instance.getInstructionsForUnlock(
            currentSelectedAchievement.id,
            0
        );

        setTitle(UnlockManager.instance.getStatHeading(currentSelectedAchievement.id));
        setDescription(instructions.instructions);
        setWorth(
            formatNumber(
                UnlockManager.instance.getAchievementWorth(currentSelectedAchievement.id)
            )
        );

        if (!achieved) {
            setPercentage(instructions.percentage);
        }

        setAchieved(achieved);
    };

    return (
        <Container
            position={PositionType.Absolute}
            width="100%"
            height="100%"
            flexDirection={FlexDirection.Row}
            justifyContent={Justify.Center}
        >
            <Column marginTop={36}>
                <Window>
                    <Column marginTop={20} alignSelf={Align.Center} width={500} rowGap={20}>
                        <WindowHeader title={Localization.instance.get('Achievements')} />
                        {/* Rank Root */}
                        <Container height={74}>
                            <Container>
                                <Panel
                                    left={45}
                                    top={12}
                                    backgroundColor={colorSwatch.RankBackground}
                                    rounding={0}
                                    width={270}
                                    height={50}
                                >
                                    <Panel
                                        margin={5}
                                        backgroundColor={colorSwatch.RankProgressBackground}
                                        rounding={0}
                                        border={0}
                                        width={260}
                                        height={40}
                                    >
                                        <Panel9Slice
                                            margin={0}
                                            material={progressMaterial}
                                            borderTextureSize={0.08}
                                            borderSize={4}
                                            rounding={0}
                                            width={xpPercentage * 250}
                                            height={40}
                                        ></Panel9Slice>
                                        <Text
                                            material={rankText}
                                            top={-34}
                                            marginLeft={28}
                                            fontSize={32}
                                            color={colorSwatch.RankText}
                                            text={rank}
                                        ></Text>
                                    </Panel>
                                </Panel>
                            </Container>

                            <Container position={PositionType.Absolute} top={0}>
                                <ColoredImage
                                    z={0.002}
                                    position={PositionType.Absolute}
                                    src={UiTexturesManager.instance.whiteCircle}
                                    color={colorSwatch.RankBackground}
                                    width={74}
                                    height={74}
                                >
                                    <ColoredImage
                                        z={0.001}
                                        margin={5}
                                        position={PositionType.Absolute}
                                        src={UiTexturesManager.instance.whiteCircle}
                                        color={colorSwatch.RankProgressBackground}
                                        width={64}
                                        height={64}
                                    >
                                        <Image
                                            z={0.001}
                                            marginLeft={10}
                                            marginTop={14}
                                            src={UiTexturesManager.instance.trophyIcon}
                                            rounding={0}
                                            width={44}
                                            height={44}
                                        ></Image>
                                    </ColoredImage>
                                </ColoredImage>
                            </Container>
                        </Container>

                        <Container flexGrow={1}>
                            <Carousel
                                height={220}
                                loop={false}
                                onSelectionChanged={onSelectionChanged}
                            >
                                {data.map((item, index) => (
                                    <CarouselItem
                                        key={index}
                                        title={item.title}
                                        id={index}
                                        image={lockImage(
                                            item.id,
                                            AchievementIcons.instance.getIcon(item.image)
                                        )}
                                    ></CarouselItem>
                                ))}
                            </Carousel>
                            <Panel
                                rounding={0}
                                height={0}
                                flexDirection={FlexDirection.Row}
                                alignContent={Align.Center}
                                justifyContent={Justify.Center}
                                alignItems={Align.Center}
                            >
                                <Row
                                    marginTop={-40}
                                    justifyContent={Justify.Center}
                                    height={20}
                                    alignItems={Align.Center}
                                >
                                    <Text
                                        textAlign="left"
                                        fontSize={20}
                                        text={worth}
                                        color={colorSwatch.UpgradeDivotFull}
                                    ></Text>
                                    <Image
                                        rounding={0}
                                        width={20}
                                        height={20}
                                        src={UiTexturesManager.instance.trophyIcon}
                                    ></Image>
                                </Row>
                            </Panel>
                            <Panel
                                rounding={0}
                                height={80}
                                backgroundColor={colorSwatch.SubTitleHighBackground}
                                flexDirection={FlexDirection.Row}
                                alignContent={Align.Center}
                                padding={10}
                                justifyContent={Justify.SpaceBetween}
                                alignItems={Align.Center}
                            >
                                <Container
                                    width="100%"
                                    height={30}
                                    alignItems={Align.Center}
                                >
                                    <Text
                                        textAlign="center"
                                        fontSize={resizeLabelToFit(title, 500, 26)}
                                        text={title}
                                        color={colorSwatch.UpgradeDivotFull}
                                    ></Text>
                                </Container>
                            </Panel>
                        </Container>
                        <Container height={30} width="100%">
                            {!isAchieved && (
                                <Container alignSelf={Align.Center} width={150} height={20}>
                                    <ProgressBar
                                        rounding={0}
                                        bgColor={colorSwatch.RequirementsBarBG}
                                        fgColor={colorSwatch.RequirementsBar}
                                        value={percentage}
                                        width={150}
                                        height={20}
                                    ></ProgressBar>
                                </Container>
                            )}
                        </Container>
                        <Container
                            height={80}
                            alignContent={Align.FlexStart}
                            alignItems={Align.Center}
                            padding={10}
                        >
                            <Text
                                color={setAlpha(colorSwatch.DescriptionText, '90%')}
                                material={rotbMats.regularTextMaterial}
                                fontSize={24}
                                textAlign="center"
                            >
                                {insertNewlines(description, 44)}
                            </Text>
                        </Container>
                        <Panel
                            rounding={0}
                            height={80}
                            backgroundColor={colorSwatch.SubTitleBackground}
                            flexDirection={FlexDirection.Row}
                            alignContent={Align.Center}
                            padding={10}
                            justifyContent={Justify.Center}
                            alignItems={Align.Center}
                        >
                            <Row
                                height={80}
                                justifyContent={Justify.Center}
                                alignContent={Align.Center}
                                alignItems={Align.Center}
                            >
                                <Text
                                    textAlign="left"
                                    fontSize={26}
                                    text={totalWorth}
                                    color={colorSwatch.UpgradeDivotFull}
                                ></Text>
                                <Image
                                    rounding={0}
                                    width={32}
                                    height={32}
                                    src={UiTexturesManager.instance.trophyIcon}
                                ></Image>
                            </Row>
                        </Panel>
                    </Column>
                </Window>
                <Row justifyContent={Justify.SpaceAround}>
                    <MenuButton
                        width={250}
                        height={54}
                        margin={6}
                        color={colorSwatch.AcceptButton}
                        fontSize={28}
                        sound={Sounds.cancel}
                        onClick={() => goToPreviousMenu(MenuPanels.Achievements)}
                    >
                        {Localization.instance.get('PurchaseFailedDialogAccept')}
                    </MenuButton>
                </Row>
            </Column>
        </Container>
    );
};
